export default "__VITE_ASSET__B2Pgz7yx__"